import makeStyles from '@mui/styles/makeStyles'

export default makeStyles((theme) => ({
    Container: {},
    ContainerExternal: {},
    ContainerTop: {
        marginBottom: '2rem',
    },
    ContainerContent: {
        padding: '1.5rem',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            padding: '2.5rem',
        },
    },
    ContainerContentNoBackground: {
        padding: '0',
        borderRadius: '0',
        overflow: 'visible',
        background: 'transparent',
        boxShadow: 'none',
    },
    TopBanner: {
        marginBottom: '3rem',
        padding: '1rem',
        background: '#ffffff',
        borderRadius: '12px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.dark}`,
        boxShadow: '0px 1px 22px rgba(7, 164, 165, 0.05)',
        maxWidth: '1616px',
        margin: '0 auto',
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            padding: '3rem',
        },
    },
    TopBannerWelcome: {},
    TopBannerWelcomeText: {
        fontSize: '2.1rem',
        fontWeight: 900,
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.grey,
    },
    TopBannerWelcomeSubtext: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.grey,
        fontSize: '1.2rem',
    },
    TopBannerButtonHolder: {
        width: '100%',
        background: '#ffffff',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.dark}`,
        boxShadow: '0 11px 22px rgba(144, 158, 159, 0.13)',
        borderRadius: 12,
        zIndex: 12,
        overflow: 'hidden',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            height: '4.65rem',
            width: 'auto',
        },
    },
    TopBannerButtonHolderOpen: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 'auto',
    },
    TopBannerHcsButton: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.lightGrey.hard,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        padding: '1.2rem 1.5rem',
        borderRadius: 0,
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            height: '4.37rem',
            minHeight: '4.37rem',
            flexDirection: 'row',
            '&:hover': {
                // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
                background: theme.palette.primary.ultraFreackingLight,
            },
        },
    },
    TopBannerHcsButtonAbsoluteSpacer: {
        height: '4.65rem',
    },
    TopBannerButtonInfosSeparator: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.dark,
        height: 2,
        borderRadius: 100,
        width: '100%',
    },
    TopBannerButtonInfos: {
        padding: '0 1.5rem',
    },
    TopBannerButtonInfosContent: {
        padding: '1.2rem 0',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1.8rem',
    },
    TopBannerHcsButtonLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '.6rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.grey,
        '& svg': {
            width: '2rem',
            height: '2rem',
            transform: 'translateY(-2px)',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            alignItems: 'center',
        },
    },
    TopBannerHcsButtonRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        fontSize: '1.2rem',
        '& *': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: theme.palette.primary.main,
        },
        '& svg': {
            width: '2.5rem',
            height: '2.5rem',
        },
    },
    TopBannerHcsButtonSeparator: {
        width: '100%',
        height: '2px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.dark,
        borderRadius: 100,
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            width: '2px',
            height: '1.4rem',
        },
    },
    TopBannerBottom: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '2rem',
        marginTop: '2rem',
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    TopBannerNotificationButton: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
        borderRadius: '100px',
        boxShadow: '0px 1px 22px rgba(45, 189, 137, 0.13)',
    },
    TopBannerNotificationButtonIcon: {
        width: '3rem',
        height: '3rem',
        borderRadius: '100px',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.consultation.ultraLight,
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            width: '1rem',
            height: '1rem',
            borderRadius: '100px',
            transform: 'translate(10%, -10%)',
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            background: theme.palette.consultation.main,
        },
    },
    TopBannerNotificationButtonIconIcon: {
        width: '1.5rem',
        height: '1.5rem',
    },
    TopBannerNotificationButtonText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.consultation.main,
    },
    TopBannerPopoverPaper: {
        marginTop: '.2rem',
        padding: 0,
    },
    TopBannerPopoverContent: {
        width: 'auto !important',
        padding: '2rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
    },
    TopBannerPopoverContentItems: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    TopBannerPopoverContentActionsButtons: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    TopBannerPopoverContentItemsItem: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.5rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            width: 'fit-content',
        },
    },
    TopBannerPopoverContentItemsItemTitle: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.lightGrey.darker,
        fontSize: '1rem',
    },
    TopBannerPopoverContentActions: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.7rem',
    },
    TopBannerPopoverContentActionsEditButton: {
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            minWidth: '12rem',
        },
    },
    TopBannerPopoverContentActionsPreferencesButton: {},
    TopBannerPopoverContentItem: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.7rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.greyDark,
    },
    TopBannerHcsButtonLeftText: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
        gap: '.7rem',
        flexDirection: 'column',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            alignItems: 'center',
            flexDirection: 'row',
        },
    },
    TopBannerHcsButtonLeftName: {
        fontSize: '1.3rem',
        fontWeight: 900,
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.grey,
    },
    TopBannerHcsButtonLeftCode: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.4rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.main,
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
            transform: 'translateY(.02rem)',
        },
    },
    TopBannerPopoverContentItemInnerIcon: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        fill: theme.palette.primary.main,
        cursor: 'pointer',
    },
}))
